import { FormattedMessage } from "react-intl";
import { OnboardingButtonExternalLink } from "./OnboardingButton";
import { LabelMedium } from "./OnboardingTypography";
import {
  FlexColumn,
  MessageBox,
  THEME,
} from "./OnboardingLayoutComponents";

const ExternalOnboardingInfo = ({
  selectedFinancialSystem,
  systemDisplayName,
  externalUrl,
}) => {
  return (
    <FlexColumn gap={THEME.spacing.xxl}>
      <MessageBox variant="info">
        <LabelMedium>
          <FormattedMessage 
            id="externalSystemMessage" 
            values={{ systemDisplayName }}
          />
        </LabelMedium>
      </MessageBox>
      
      {externalUrl && (
        <FlexColumn style={{ alignItems: "flex-start" }}>
          <OnboardingButtonExternalLink 
            href={externalUrl} 
            target="_blank" 
            rel="noopener noreferrer"
          >
            <LabelMedium>
              <FormattedMessage id="readMoreButton" />
            </LabelMedium>
          </OnboardingButtonExternalLink>
        </FlexColumn>
      )}
    </FlexColumn>
  );
};

export default ExternalOnboardingInfo;